import { css } from "@linaria/core";

export const optionCls = css`
  margin-bottom: 10px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const buttonCls = css`
  -webkit-appearance: none;
  background: none;
  border: none;
  outline: none;

  width: calc(100% + 60px);
  padding: 10px 30px;
  margin: -5px -30px;

  color: #262626;
  font-family: var(--font-family);
  font-size: calc(16 * var(--font-px));
  font-weight: 600;
  line-height: 1.25;
  text-align: left;

  cursor: pointer;
  transition: color 0.1s linear, background-color 0.1s linear;

  &:hover,
  &:focus {
    color: var(--color-primary);
    background-color: #f9f9f9;
  }
`;
